// SelectionMark.js
import { Mark, mergeAttributes } from "@tiptap/core";

const SelectionMark = Mark.create({
  name: "selectionMark",
  parseHTML() {
    return [{ tag: "span.selection" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, { class: "selection" }), 0];
  },
  addCommands() {
    return {
      setSelectionMark:
        () =>
        ({ commands }) =>
          commands.setMark(this.name),
    };
  },
});

export default SelectionMark;
